import { PATH } from '@repo/constants';
import { isMaintenanceActive, useMaintenanceQuery } from '@repo/lib';
import { MaintenanceType } from '@repo/types';
import { FC, ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface MaintenanceProviderProps {
  children: ReactNode;
  type: MaintenanceType;
}

export const MaintenanceProvider: FC<MaintenanceProviderProps> = ({
  children,
  type,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { maintenance } = useMaintenanceQuery(type);

  useEffect(() => {
    if (
      maintenance?.date_from &&
      maintenance?.date_to &&
      !maintenance?.is_disabled
    ) {
      if (isMaintenanceActive(maintenance)) {
        if (location.pathname !== PATH.MAINTENANCE) {
          navigate(PATH.MAINTENANCE + '/' + type);
        }
      }
    }
  }, [maintenance, location]);

  return <>{children}</>;
};
